import { render, staticRenderFns } from "./co-applicant-carousel-item.vue?vue&type=template&id=5a8f8ef5"
import script from "./co-applicant-carousel-item.vue?vue&type=script&lang=js"
export * from "./co-applicant-carousel-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports